<template>
  <template v-if="user">
    <ion-item
      v-for="vehicle in user.customer.vehicles"
      v-bind="$attrs"
      :key="`my-vehicle-${vehicle.id}`"
      button
      lines="none"
      class="ion-margin-top-sm"
      @click="$router.push({
        name: more ? 'more-profile-car' : 'profile-car',
        params: { id: vehicle.id },
      })"
    >
      <ion-thumbnail
        slot="start"
        class="vehicle"
      >
        <car-logo :vehicle="vehicle" />
      </ion-thumbnail>
      <ion-label>
        <h3>{{ vehicle.brand }} {{ vehicle.model }}</h3>
        <h2>{{ vehicle.identifiers.find(i => i.type === 'license_plate')?.value ?? null }}</h2>
      </ion-label>
    </ion-item>
    <slot :add="openAddCar" />
  </template>
  <ion-item
    v-else
    v-bind="$attrs"
  >
    <ion-thumbnail
      slot="start"
      class="vehicle"
    >
      <img src="img/placeholder.jpg">
    </ion-thumbnail>
    <ion-label>
      <h3>
        <ion-skeleton-text
          style="width: 30%;"
          animated
        />
      </h3>
      <h2>
        <ion-skeleton-text
          style="width: 70%;"
          animated
        />
      </h2>
    </ion-label>
  </ion-item>
</template>

<script>
import { defineComponent } from 'vue';
import {
  modalController,
} from '@ionic/vue';
import CarLogo from '@/components/CarLogo.vue';
import AddCar from '@/components/AddCar.vue';
import ErrorMixin from '@/mixins/ErrorMixin';
import MoreMixin from '@/mixins/MoreMixin';
import store from '@/store';

export default defineComponent({
  components: {
    CarLogo,
  },
  mixins: [ErrorMixin, MoreMixin],
  inheritAttrs: false,
  computed: {
    user: () => store.user,
  },
  methods: {
    /**
     * Open add car.
     */
    async openAddCar() {
      const modal = await modalController.create({
        component: AddCar,
        showBackdrop: false,
      });
      await modal.present();
      await modal.onDidDismiss();
    },
  },
});
</script>

<style scoped>
ion-input {
  background: var(--ion-color-plate);
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
}

ion-item {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  font-size: 16px;

  --background: var(--ion-color-light);

  ion-thumbnail.vehicle {
    width: 81px;
    height: 80px;
    margin: 0 20px 0 -16px;
    padding: 10px;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }

  ion-label {
    h3 {
      font-size: 14px;
      font-weight: 500;
    }

    h2 {
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0;
    }
  }
}

.ios ion-thumbnail.vehicle {
  margin-left: -20px;
}
</style>
